import React, { memo, useCallback, useEffect, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import {Card, CardMedia, CardContent, CardActionArea, Typography, Collapse, Divider, Stack, LinearProgress} from '@mui/material';
import { WordTransform } from '../utils/other';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useDispatch, useSelector } from 'react-redux';
import { dataError, dataImg, dataLoading, fetchImg } from '../../storeredux';

const ImageContainer = ({keyImg,imgs,open,title,descTitle}) => {
  const AutoPlayPlayer = autoPlay(SwipeableViews)
  const changeHeight = () => {
    if (open) return 250
    else return 150
  }

  const changeRotate = () => {
    if (open) return 180
    else return 0
  }

  const changeState = () => {
    if (open) return 'center'
    else return 'end'
  }

  return <AutoPlayPlayer id={`act-cont-auto-${keyImg}`} interval={3000}>
    {
      (imgs.length > 0)?
        imgs.map((image,i) => (
          <CardMedia
            component="div"
            key={i}
            image={image.data}
            title={title}
            sx={{width: '100%',height:`${changeHeight()}px`,transition: 'all .5s ease-in'}}
          >
            <Stack sx={{width: '100%',height: '100%',
                background: 'linear-gradient(0deg, #000000, rgba(0,0,0,0))',
                justifyContent:changeState(), transition: 'all .5s ease-in'}}>
              <Typography
                variant='h4'
                sx={{textAlign: "center",width: '100%',color: "white",fontFamily:'Century Gothic',
                  backgroundColor: "none",fontWeight:700}}
              >
                {title}
              </Typography>
              <Typography
                variant='body1'
                sx={{width: '100%',textAlign: "center",fontFamily:'Century Gothic',
                  color: "white",backgroundColor: "none"}}
              >
                {descTitle}
              </Typography>
              <ExpandMore sx={{width: '100%',margin:'auto,0,10px,0',color:'white',
                transform: `rotate(${changeRotate()}deg)`,transition: 'all .5s ease-in'}}/>
            </Stack>
          </CardMedia>
        )): 
        <Stack sx={{width: '100%', height:`${changeHeight()}px`, background: 'linear-gradient(0deg, #000000, rgba(0,0,0,0))',
            justifyContent:changeState(), transition: 'all .5s ease-in'}}>
          <Typography
            variant='h4'
            sx={{textAlign: "center",width: '100%',color: "white",fontFamily:'Century Gothic',
              backgroundColor: "none",fontWeight:700}}
          >
            {title}
          </Typography>
          <Typography
            variant='body1'
            sx={{width: '100%',textAlign: "center",fontFamily:'Century Gothic',
              color: "white",backgroundColor: "none"}}
          >
            {descTitle}
          </Typography>
          <ExpandMore sx={{width: '100%',margin:'auto,0,10px,0',color:'white',
            transform: `rotate(${changeRotate()}deg)`,transition: 'all .5s ease-in'}}/>
        </Stack>
    }
  </AutoPlayPlayer>
}

export const ActivityContainer = memo(function({setError,index,images,title,descTitle,descMain,rilis,clr}) {
  const [open,setOpen]= useState(false);
  const {format} = require('date-fns');
  const imgs = useSelector(dataImg)
  const err = useSelector(dataError)
  const loading = useSelector(dataLoading)
  const dispatch = useDispatch()
  const handleClick = useCallback(() => {
    setOpen(!open)
  },[setOpen,open])

  useEffect(() => {
    if (images.length > 0) {
      for (const img of images) {
        if (imgs.filter((dt) => dt.name === img).length <= 0) {
          dispatch(fetchImg({imgname:img,index:index,type:'activity'}))
        } else break
      }
    }
  },[images])
  useEffect(() => {
    setError(err)
  },[err])

  var colorTheme = [
    {title:"#ff9933",rilis:'#c77b48',main:'#ffb366',link:'#ff9900',footer:'#bf8040'},
    {title:"#00b33c",rilis:'#80ffaa',main:'#00e673',link:'#00cc66',footer:'#33cc33'},
    {title:"#00b3b3",rilis:'#80e5ff',main:'#33cccc',link:'#0099cc',footer:'#0077b3'},
    {title:"#9933ff",rilis:'#d9b3ff',main:'#cc66ff',link:'#cc33ff',footer:'#ac00e6'},
  ]

  const para = () => {
    return WordTransform.getTransform(descMain,colorTheme[clr].main)
  }

  const visible = () => (
    <>
      <CardActionArea component="div" onClick={handleClick} sx={{width:"100%"}}>
            <ImageContainer keyImg={index} imgs={(imgs.length > 0)?imgs.filter(dt => dt.index === index && dt.type === 'activity'):[]} open={open} title={title} descTitle={descTitle}/>
        </CardActionArea>
      <Collapse in={open} timeout="auto" >
        <CardContent style={{textAlign:'center', display: 'block'}}>
          <Typography variant='h5' style={{color:colorTheme[clr].title}} sx={{fontFamily:'Candara',marginBottom:'10px',fontWeight:600}}>
            {descTitle}
          </Typography>
          <Divider variant='middle' light/>
          <Typography style={{color:colorTheme[clr].rilis}} sx={{textAlign:'right',marginTop:'15px',fontFamily:'Arial'}} paragraph>
            <i>{
              format(new Date(rilis), 'dd/MM/yyyy')
            }</i>
          </Typography>
          {para()}
        </CardContent>
        <CardContent style={{backgroundColor:colorTheme[clr].footer}}>
          <Typography variant='body1' sx={{color: '#ebebe0',textAlign: 'center'}}>
            <i>@ActivityReport</i>
          </Typography>
        </CardContent>
      </Collapse>
    </>
  )

  const loadinit = () => (
    <CardContent style={{justifyContent:'center',alignItems:'center',display: 'flex',flexWrap:'wrap',background:'#e3e3e3'}}>
      <LinearProgress color="success" sx={{width:'100%'}}/>
      <Typography variant='h6' color="green">Loading</Typography>
    </CardContent>
  )

  return(
    <Card elevation={5} sx={{width:'100%',maxWidth:'800px'}}>
      {
        (loading)?loadinit():visible()
      }
    </Card>
  )
})
